// extracted by mini-css-extract-plugin
export default {"link":"link_DoPfB","arrow":"arrow_Gip5l","wrapper":"wrapper_Oz7Ui"};